<template>
  <div
    class="window confirm-dialog"
    :style="{
      top: position.y + 'px',
      left: position.x + 'px',
      position: 'absolute',
      zIndex: zIndex
    }"
    @mousedown="bringToFront"
  >
    <div class="title-bar" @mousedown.stop.prevent="startDrag">
      <div class="title-bar-text">Confirm</div>
      <div class="title-bar-controls">
        <button aria-label="Close" @click="cancel"></button>
      </div>
    </div>
    <div class="window-body">
      <p>{{ message }}</p>
      <div class="dialog-buttons">
        <button class="btn" @click="confirm">Yes</button>
        <button class="btn" @click="cancel">No</button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';

const props = defineProps({
  message: String,
  onConfirm: Function,
  onCancel: Function,
});

const position = ref({ x: 0, y: 0 });
const zIndex = ref(0);

function bringToFront() {
  zIndex.value = getNextZIndex();
}

function getNextZIndex() {
  if (!window._zCounter) window._zCounter = 1000;
  return ++window._zCounter;
}

function startDrag(e) {
  bringToFront();
  const offsetX = e.clientX - position.value.x;
  const offsetY = e.clientY - position.value.y;

  const onMouseMove = (e) => {
    position.value.x = e.clientX - offsetX;
    position.value.y = e.clientY - offsetY;
  };

  const onMouseUp = () => {
    window.removeEventListener('mousemove', onMouseMove);
    window.removeEventListener('mouseup', onMouseUp);
  };

  window.addEventListener('mousemove', onMouseMove);
  window.addEventListener('mouseup', onMouseUp);
}

function confirm() {
  props.onConfirm();
}

function cancel() {
  props.onCancel();
}

onMounted(() => {
  // Posiziona la finestra al centro dello schermo
  const windowWidth = window.innerWidth;
  const windowHeight = window.innerHeight;
  const dialogWidth = 300; // Larghezza stimata della finestra
  const dialogHeight = 60; // Altezza stimata della finestra

  position.value.x = (windowWidth - dialogWidth) / 2;
  position.value.y = (windowHeight - dialogHeight) / 2;

  bringToFront();
});
</script>

<style scoped>
.confirm-dialog {
  width: 300px;
  min-height: 60px;
  resize: none;
  box-sizing: border-box;
}

.dialog-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 10px;
}
</style>